'use strict';

import * as angular from 'angular';
var app = angular.module('noc.config', []);

app.service('ConfigurationStoreService', require('./store/configurationStoreService'));
app.service('ProjectConfigurationService', require('./services/projectConfigurationService'));
app.service('TrainTypeConfigurationService', require('./services/trainTypeConfigurationService'));

export default app;